import { Input } from '@heroui/react';
import React from 'react';
import { FiSearch } from 'react-icons/fi';

export interface SearchInputProps {
  /** Current search value */
  value: string;
  /** Placeholder text for the search input */
  placeholder?: string;
  /** Change handler for search input */
  onChange: (value: string) => void;
  /** Whether the input is disabled */
  disabled?: boolean;
  /** Additional CSS classes */
  className?: string;
  /** Aria label for accessibility */
  ariaLabel?: string;
  /** Input size variant */
  size?: 'sm' | 'md' | 'lg';
}

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  placeholder = 'Search...',
  onChange,
  disabled = false,
  className = '',
  ariaLabel,
  size = 'sm',
}) => {
  return (
    <Input
      type="text"
      placeholder={placeholder}
      value={value}
      onValueChange={onChange}
      startContent={<FiSearch className="text-default-400" />}
      variant="bordered"
      size={size}
      isDisabled={disabled}
      aria-label={ariaLabel || placeholder}
      className={className}
      classNames={{
        // !outline-none suppresses HeroUI's dark inner focus outline, which
        // has a different radius than our filled wrapper and rendered as an
        // ugly doubled/mismatched ring. Focus is shown by the wrapper's
        // focus-within:border-primary instead.
        input: 'text-foreground bg-transparent px-3 py-2 !outline-none',
        inputWrapper:
          'bg-default-100 border-default-300 hover:border-default-400 focus-within:border-primary transition-colors duration-200',
      }}
    />
  );
};
